/**
 * 文字图片元素转换图片 elementDraw
 * @param  {Object} item 传入的参数
 * @param  {Array} item.WH  图片的宽高
 * @param  {String} item.backgroundColor 图片背景色 默认值 #fff
 * @param  {Number} item.quality   图片质量 取值范围0-1  默认值 1
 * @param  {Array} item.image   文案图片 (文案图片转换时需要)
 * @param  {Array} item.text   文案图片 (文案图片转换时需要)
 * @param  {String} item.image.src   图片地址
 * @param  {Array} item.image/text.pos   [x, y, width, height] || [x, y]
 * @param  {String} item.text.text   文案
 * @param  {Object} item.text.style   文字样式  color/font  默认值 #333 14px
 * @return {Function}    图片src (Promise实例 .then去获取返回值)
 */
export const elementDraw = async function (item) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  canvas.width = item.WH[0]
  canvas.height = item.WH[1]
  context.fillStyle = item.backgroundColor || '#fff'
  context.fillRect(0, 0, item.WH[0], item.WH[1])
  const src = await drawElement(item, canvas, context)
  return Promise.resolve(src)
}

/**
 * 加载图片
 * @param  {[String]} src  图片地址
 * @return {[object]}     图片元素
 */
function loadImg(src) {
  return new Promise((resolve) => {
    const img = new Image()
    img.setAttribute('crossOrigin', 'anonymous')
    img.src = src
    img.onload = () => {
      resolve(img)
    }
  })
}

/**
 * 绘制文字和图片
 * @param  {[type]} info    [description]
 * @param  {[type]} canvas  canvas画布
 * @param  {[type]} context canvas context
 * @return {[String]}      图片src
 */
async function drawElement(info, canvas, context) {
  const imageType = info.imageType || 'image/jpeg'
  let loadTextList = []
  const loadImgList = info.image.map(async (item, key) => {
    const x = item.pos[0] || 0
    const y = item.pos[1] || 0
    const width = item.pos[2] || info.WH[0]
    const height = item.pos[3] || info.WH[1]
    const img = await loadImg(item.src)
    context.drawImage(img, x, y, width, height)

    // 图片是在onload完成后再进行绘制
    // 如果文字绘制不放置在onload图片处理之下就不能保证文字绘制代码已经执行而图片才加载
    if (key === info.image.length - 1) {
      loadTextList = await drawText(info, canvas, context)
    }
    return Promise.resolve()
  })

  const list = loadTextList.concat(loadImgList)

  return new Promise((resolve) => {
    Promise.all(list).then(() => {
      const src = canvas.toDataURL(imageType, info.quality || 1)
      resolve(src)
    })
  })
}

/**
 * 绘制文字
 * @param  {[type]} info    [description]
 * @param  {[type]} canvas  canvas画布
 * @param  {[type]} context canvas context
 * @return {[String]}      文字绘制数组
 */
async function drawText(info, _canvas, context) {
  const loadTextList = info.text.map(async (item) => {
    const x = item.pos[0] || 0
    const y = item.pos[1] || 0
    context.fillStyle = item.style ? item.style.color : '#333'
    context.font = item.style ? item.style.font : '14px'
    context.textAlign = item.style ? item.style.textAlign : 'start'
    context.fillText(item.text, x, y)
    return Promise.resolve()
  })

  return loadTextList
}
